// extracted by mini-css-extract-plugin
export default {"button":"PrintResults_button__+BH0C","row":"PrintResults_row__uUnNG"};